// Solomon Portal v1 — App router.
// Uses createBrowserRouter (RR7 SPA mode).

import { createBrowserRouter, RouterProvider } from 'react-router';
import { AuthProvider } from './lib/auth';
import { PortalShell } from './components/layout/PortalShell';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { IndexRoute } from './routes/index';
import { LoginRoute } from './routes/login';
import { AuthCallbackRoute } from './routes/auth-callback';
import {
  AuthExpiredRoute,
  AuthInvalidLinkRoute,
  AuthAlreadyUsedRoute,
  AuthGenericErrorRoute,
} from './routes/auth-error';
import { NotProvisionedRoute } from './routes/not-provisioned';
import { SupportRoute } from './routes/support';
import { ConversationDetailRoute } from './routes/conversation-detail';
import { NewConversationRoute } from './routes/new-conversation';

const router = createBrowserRouter([
  { path: '/', element: <IndexRoute /> },
  { path: '/login', element: <LoginRoute /> },
  { path: '/auth/callback', element: <AuthCallbackRoute /> },
  { path: '/auth/expired', element: <AuthExpiredRoute /> },
  { path: '/auth/invalid-link', element: <AuthInvalidLinkRoute /> },
  { path: '/auth/already-used', element: <AuthAlreadyUsedRoute /> },
  { path: '/auth/error', element: <AuthGenericErrorRoute /> },
  { path: '/not-provisioned', element: <NotProvisionedRoute /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <PortalShell />,
        children: [
          { path: '/support', element: <SupportRoute /> },
          // /support/new MUST come BEFORE /support/:conversationNumber
          // so the literal segment wins routing precedence (react-router
          // does prefer literals over params, but listing first is the
          // explicit, audit-friendly form).
          { path: '/support/new', element: <NewConversationRoute /> },
          {
            path: '/support/:conversationNumber',
            element: <ConversationDetailRoute />,
          },
        ],
      },
    ],
  },
]);

export function App(): React.ReactNode {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
